export const FETCH_LOGIN_REQUEST='FETCH_LOGIN_REQUEST'
export const FETCH_LOGIN_SUCCESS='FETCH_LOGIN_SUCCESS'
export const FETCH_LOGIN_FAILURE='FETCH_LOGIN_FAILURE'
export const LOGOUT_SUCCESS='LOGOUT_SUCCESS'
export const CHANGE_IMAGE='CHANGE_IMAGE'